module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down-evenodd.2fed0a59.svg";